<div>
  <app-select *ngIf="isShow" [selectClass]="'ng-form-select primary-select'" [options]="types" (selectedValueChange)="onChangeRestaurant($event)"
              selectPlaceholder="Select Resto" [(selectedValue)]="typeSelect"></app-select>
  <div class="mt-3">
    <ng-component *ngIf="!blockElement?.isActiveForEdit && displayHtml != null" [innerHTML]="displayHtml"></ng-component>
    <div *ngIf="blockElement?.isActiveForEdit && typeSelect" class="NgxEditor__Wrapper mt-3">
      <ngx-editor [editor]="editor" [formControl]="editorControl" (ngModelChange)="onChange($event)"></ngx-editor>
    </div>
  </div>
</div>
